module.exports = __webpack_public_path__ + "img/piiri_p.def2ecd2.png";